import type { ReactNode } from 'react';

export const symbol_encrypted: ReactNode = (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960">
		<path
			fill="currentColor"
			d="M447-360h66q6.75 0 11.88-5.63Q530-371.25 528-378l-22-127q20.47-9.15 32.23-26.55Q550-548.94 550-570q0-28.88-20.59-49.44T479.91-640q-28.91 0-49.41 20.56Q410-598.88 410-570q0 21.06 11.77 38.45Q433.53-514.15 454-505l-22 127q-2 6.75 3.13 12.37Q440.25-360 447-360Zm23.12 275q-4.56-1-9.12-3-139-47-220-168.5t-81-266.61V-719q0-19.26 10.88-34.66Q181.75-769.07 199-776l260-97q11-4 21-4t21 4l260 97q17.25 6.93 28.13 22.34Q800-738.26 800-719v195.89Q800-378 719-256.5T499-88q-4.56 2-9.12 3T480-84q-5.32 0-9.88-1Zm9.88-58q115-38 187.5-143.5T740-523v-196l-260-98-260 98v196q0 131 72.5 236.5T480-143Zm0-337Z"
		/>
	</svg>
);
